import React, { useEffect, useState } from "react";
import {
  Divider,
  Card,
  IconButton,
} from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { Link, useParams } from "react-router-dom";
import { baseURL } from "utils/api";
import { ArrowCircleRightOutlined, ArrowBack } from "@mui/icons-material";
import Loading from "components/ApnaLoading";
import { useSelector } from "react-redux";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

const index = () => {

   const userTheme = useSelector((state) => state.commonSlice.theme);
   const [data, setData] = useState(null);
   const { id } = useParams();
   const [loading, setLoading] = useState(false);


  const fetchData = (ev) => {
    setLoading(true); 
    fetch(`${baseURL}getOfferById/${ev}`)
      .then(res => res.json())
      .then(data => {
        console.log(data,'detail')
        if (data.success) {
          setLoading(false);
          setData(data?.data)
        }
      }).catch(err => {
        toast.error(err.message || 'Something went wrong');
      });
  };

  useEffect(() => {
    fetchData(id)
  }, [id]);


  const formatKey = (key) => {
    return key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase());
  };

  function formatDate(value) {
    const date = new Date(value);
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Add 1 because months are zero-based
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  }

  return (
      <DashboardLayout>
          <DashboardNavbar />
    {
      loading?<Loading/>:
   
      <Card className="glassmorphism-card"
        sx={{
          mt: '5px',
          width: "100%",
          minHeight: 400,
          padding: '26px',
          boxShadow: 2,
        }}
      >
        <SoftBox sx={{ display: "flex", alignItems: "center" }} gap={2}>
        <Link to="/offers">
            <ArrowCircleRightOutlined
              style={{ transform: "rotate(180deg)", color: userTheme == 'dark' ? "#ffffff" : "#141414" }}
            />
          </Link>
          <SoftTypography
            variant="h6"
            textAlign="left"
            fontSize='1rem'
            gutterBottom
          >
            Offer Details
          </SoftTypography>
        </SoftBox>

        <Divider className="devider" sx={{ mb: 2 }} />

        {data !== null &&
          <SoftBox>
            {Object.entries(data).map(([key, value]) => (
              (key !== '_id' && key !== 'status' && key !== 'businesses' && key !== 'createdAt' && key !== 'updatedAt' && key !== '__v') && (
                <SoftBox key={key} sx={{ mb: 2, display: "flex", alignItems: 'center' }}>
                  <SoftTypography
                    variant="button"
                    fontWeight="bold"
                    textTransform="capitalize"
                    sx={{ color: '#344767', fontSize: 14 }}
                  >
                    {key === 'isActive' ? 'Status' : formatKey(key)}:
                  </SoftTypography>
                  <SoftTypography
                    variant="button"
                    fontWeight="regular"
                    color="text"
                    sx={{ marginLeft: "10px", fontSize: 14 }}
                  >
                    {
                      key === 'startDate' || key === 'endDate'
                        ? formatDate(value)
                        : key === 'category' || key === 'subCategory'
                          ? value?.name
                          : key === 'isActive'
                            ? value ? 'Active' : 'Inactive'
                            : key === 'businessLocations'
                              ? <SoftBox>
                                {value && value.length > 0 && value.map((loc, index) => (
                                  <SoftTypography key={index} sx={{ display: 'inline', fontSize: 14 }}>
                                    {loc?.locationName ? loc?.locationName : loc?.location}{index !== value.length - 1 ? ', ' : ''}
                                  </SoftTypography>
                                ))}
                              </SoftBox>
                              : typeof value === 'object'
                                ? JSON.stringify(value, null, 2)
                                : value
                    }
                  </SoftTypography>
                </SoftBox>
              )
            ))}
          </SoftBox>
        }
      </Card>
       }
    </DashboardLayout>
  );
};

export default index;
